import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './Landing';
import Simulator from './Simulator';
import Analytics from './Analytics';
import MediaKit from './MediaKit';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/simulator" element={<Simulator />} />
        <Route path="/mediakit" element={<MediaKit />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;